<template>

    <DataTable class="datatable-license" dataKey="serial_number"
        expandableRowGroups v-model:expandedRowGroups="expandedRowGroups" rowGroupMode="subheader" groupRowsBy="product.application"
        :value="licensesToShowSortedUpdating" v-model:selection="selectedLicenses" row resizableColumns columnResizeMode="fit" scrollable scrollHeight="flex" tableStyle="" :row-class="() => 'row'" @row-dblclick="(event) => openLicenseWindow(event.data)" :style="`max-height: ${licensesDatatableHeight}px;`" style="min-height: 33.43rem;"  
    >
        <template #empty>
            <div v-if="licenses.length > 0" class="w-full flex flex-row justify-content-center align-items-center py-3" style="background-color: var(--table-row-color)">
                <span class="flex flex-column align-items-center justify-content-center">
                    <span>No license matches the filters applied.</span>
                    <span>Change or clear the filters to see your licenses.</span>
                </span>
            </div>
            <div v-else class="w-full flex flex-row justify-content-center align-items-center py-3" style="background-color: var(--table-row-color)">
                <span>
                    No license found. Click on
                    <span style="font-weight: var(--font-weight-normal);">Add a Serial Number</span>
                    button to add one.
                </span>
            </div>
        </template>
        <!-- Groups header -->
        <template #groupheader="{ data }">
            <img :alt="data.product.application" :src="data.product.icon_url" width="32" style="vertical-align: middle" class="ml-2" />
            <span v-if="applicationsInfo[allApplications.indexOf(data.product.application)]" class="group-header-content font-bold" translate="no">
                <span class="ml-2 line-height-3" style="font-size: var(--table-groupheader-app-font-size); font-weight: var(--table-groupheader-app-font-weight);">{{ data.product.application }}</span>
                <span class="ml-3 mr-3" style="font-size: var(--table-groupheader-latestversion-font-size); font-weight: var(--table-groupheader-latestversion-font-weight);">-</span>
                <a id="latest-version-text" class="cursor-pointer" :href="data.product.download_url ? data.product.download_url : 'https://softron.tv/support/downloads'" target="_blank">
                    <span style="font-size: var(--table-groupheader-latestversion-font-size); font-weight: var(--table-groupheader-latestversion-font-weight);">Latest version: {{ data.product.latest_version }}</span>
                    <SvgDownload className="table-licenses-download-svg" class="ml-2" color="var(--theme-font-color)"/>
                </a>
                <span style="font-size: var(--table-groupheader-summary-font-size); font-weight: var(--table-groupheader-summary-font-weight);">
                    <span class="status-summary-total">({{ applicationsInfo[allApplications.indexOf(data.product.application)].total }})</span>
                    <span class="status-summary-available">Available: {{ applicationsInfo[allApplications.indexOf(data.product.application)].available }}</span>
                    <span class="status-summary-inuse">In Use: {{ applicationsInfo[allApplications.indexOf(data.product.application)].inuse }}</span>
                </span>
            </span>
        </template>


        <!-- Left side "Columns" -->
        
        <Column field="" header="" style="min-width: 4.5rem; width: 4.5rem; max-width: 4.5rem;"></Column>

        <Column field="product.application" header="Application" style=""></Column>
    
        <Column selectionMode="multiple" style="min-width: 2rem; width: 2rem; max-width: 2rem;"/>

        <!-- DATA COLUMNS -->

        <!-- License (Serial Number) -->
        <Column field="serial_number" header="License" style="width: 16%; min-width: 2.2rem; max-width: 9rem" class="resize"> <!-- headerStyle="transform: translateX(-1.5rem)"> -->
            <template #body="slotProps">
                <div class="flex flex-row align-items-center justify-content-center">
                    <span class="potentially-long-label text-serial-number">{{slotProps.data.serial_number}}</span>
                </div>
            </template>
        </Column>

        <!-- Description -->
        <Column field="product.options" style="min-width: 9rem; max-width: 35rem" class="resize">
            <template #header>
                <div class="w-full flex flex-row align-items-center justify-content-center">
                    <span class="p-column-title">Description</span>
                </div>
            </template>
            <template #body="slotProps">
                <div class="relative w-full" style="margin-top: 0.6rem; height: 2rem;">
                    <ScrollDescriptionText :type="slotProps.data.product.type" :version="slotProps.data.product.version" :exp="slotProps.data.product.exp" :options="slotProps.data.product.options"/>
                </div>
            </template>
        </Column>

        <!-- Channels -->
        <Column field="product.channels" style="width: 7rem; min-width: 6rem; max-width: 9rem" class="resize">
            <template #header>
                <div class="w-full flex flex-row align-items-center justify-content-center">
                    <span class="p-column-title">Channels</span>
                </div>
            </template>
            <template #body="slotProps">
                <div class="flex flex-row align-items-center justify-content-center">
                    <span>{{slotProps.data.product.channels}}</span>
                </div>
            </template>
        </Column>

        <!-- Owner -->
        <Column field="admin" style="width: 7rem; min-width: 6rem; max-width: 9rem" class="resize">
            <template #header>
                <div class="w-full flex flex-row align-items-center justify-content-center">
                    <span class="p-column-title">Owner</span>
                </div>
            </template>
            <template #body="slotProps">
                <div class="h-full w-full flex flex-row justify-content-center align-items-center" @click="emit('selected-user-changed',(selectedUser === slotProps.data.admin) ? null : slotProps.data.admin)">
                    <Avatar v-if="user.id===slotProps.data.admin.id" class="avatar" :class="{ 'is-active-user': ((slotProps.data.current_status.activeUser) && (slotProps.data.admin.id === slotProps.data.current_status.activeUser.id)), 'is-user': user.id===slotProps.data.admin.id, 'is-selected-user': (selectedUser!==null ? selectedUser.id : '')===slotProps.data.admin.id}" size="small" shape="circle" v-tooltip.top="{ value: getTooltipValueForUser(slotProps.data.admin, slotProps.data.current_status.activeUser) }">
                        <SvgUserMe className="avatar-me-svg" :color="((slotProps.data.current_status.activeUser) && (slotProps.data.admin.id === slotProps.data.current_status.activeUser.id)) ? 'var(--avatar-inuse-font-color)' : 'var(--theme-font-color)'"/>
                    </Avatar>
                    <Avatar v-else class="avatar" :class="{ 'is-active-user': ((slotProps.data.current_status.activeUser) && (slotProps.data.admin.id === slotProps.data.current_status.activeUser.id)), 'is-user': user.id===slotProps.data.admin.id, 'is-selected-user': (selectedUser!==null ? selectedUser.id : '')===slotProps.data.admin.id}" :label="getAvatarLabelFromFirstNameAndLastName(slotProps.data.admin.first_name, slotProps.data.admin.last_name)" size="small" shape="circle" v-tooltip.top="{ value: getTooltipValueForUser(slotProps.data.admin, slotProps.data.current_status.activeUser) }"/>
                </div>
            </template>
        </Column>

        <!-- Users -->
        <Column field="accessUser" style="width: 13%; min-width: 3rem; max-width: 16rem" class="resize">
            <template #header>
                <div class="w-full flex flex-row align-items-center justify-content-center">
                    <span class="p-column-title">Users</span>
                </div>
            </template>
            <template #body="slotProps">
                <div class="mt-2 relative w-full" style="height: 2.4rem;">
                    <ScrollDelegatesAvatars :delegates="slotProps.data.delegates" :activeUser="slotProps.data.current_status.activeUser" :selectedUser="selectedUser" @clicked-avatar="(val) => emit('selected-user-changed', (selectedUser === val) ? null : val)"/>
                </div>
            </template>
        </Column>

        <!-- Status -->
        <Column field="activation.activated" class="status" style="width: 17%; min-width: 5rem; max-width: 20rem">
            <template #header>
                <div class="w-full flex flex-row align-items-center justify-content-center">
                    <span class="p-column-title">Status</span>
                </div>
            </template>
            <template #body="slotProps">
                <div class="flex flex-row justify-content-center align-items-center">
                    <StatusTag :statusInformation="slotProps.data.current_status" :pending="isPendingNow(slotProps.data) ? slotProps.data.pending : null" tooltipPosition="left" tagSize="small" :applicationName="slotProps.data.product.application"/>
                </div>
            </template>
        </Column>


        <!-- Right side "Column" -->
        <Column headerStyle="width: 0rem" style="width: 6rem; max-width: 6rem">
            <template #body="slotProps">
                <div class="license-side-buttons flex flex-row justify-content-end align-items-center">
                    <!-- <Button v-if="slotProps.data.admin.id === user.id" text rounded id="delete-license-button" icon="pi pi-trash" aria-label="Search" @click="deleteSerialNumber(slotProps.data)" style="height: 2.5rem; width: 2.5rem;"/> -->
                    <div v-if="!isOldActivation(slotProps.data) && slotProps.data.current_status.activated === true && slotProps.data.current_status.activeUser && slotProps.data.current_status.activeUser.id == user.id" v-tooltip.left="{ value: 'You can not remove a license that you are currently running. Release it on the computer where it is activated to be able to remove it from your account.', showDelay: 700 }">
                        <Button text rounded id="delete-license-button" aria-label="Search" disabled style="height: 2.5rem; width: 2.5rem; border-radius: 980px;" @mouseenter="delItemSerialNumber = slotProps.data.serial_number" @mouseleave="delItemSerialNumber = null">
                            <SvgTrash className="table-licenses-svg" :color="delItemSerialNumber === slotProps.data.serial_number ? 'var(--button-danger-color)' : 'var(--button-normal-color)'"/>
                        </Button>
                    </div>
                    <div v-else-if="slotProps.data.admin.id === user.id">
                        <div v-if="!isOldActivation(slotProps.data) && slotProps.data.current_status.activated === true" v-tooltip.left="{ value: 'You can not remove a license that is in use if you are its owner. Release it on the computer where it is activated to be able to remove it from your account.', showDelay: 700 }">
                            <Button text rounded id="delete-license-button" aria-label="Search" disabled style="height: 2.5rem; width: 2.5rem; border-radius: 980px;" @mouseenter="delItemSerialNumber = slotProps.data.serial_number" @mouseleave="delItemSerialNumber = null">
                                <SvgTrash className="table-licenses-svg" :color="delItemSerialNumber === slotProps.data.serial_number ? 'var(--button-danger-color)' : 'var(--button-normal-color)'"/>
                            </Button>
                        </div>
                        <Button v-else text rounded id="delete-license-button" aria-label="Search" @click="deleteSerialNumber(slotProps.data)" style="height: 2.5rem; width: 2.5rem; border-radius: 980px;" @mouseenter="delItemSerialNumber = slotProps.data.serial_number" @mouseleave="delItemSerialNumber = null">
                            <SvgTrash className="table-licenses-svg" :color="delItemSerialNumber === slotProps.data.serial_number ? 'var(--button-danger-color)' : 'var(--button-normal-color)'"/>
                        </Button>
                    </div>
                    <Button v-else text rounded id="delete-license-button" aria-label="Search" @click="deleteSerialNumber(slotProps.data)" style="height: 2.5rem; width: 2.5rem; border-radius: 980px;" @mouseenter="delItemSerialNumber = slotProps.data.serial_number" @mouseleave="delItemSerialNumber = null">
                        <SvgTrash className="table-licenses-svg" :color="delItemSerialNumber === slotProps.data.serial_number ? 'var(--button-danger-color)' : 'var(--button-normal-color)'"/>
                    </Button>
                    <Button text rounded aria-label="Search" @click="openLicenseWindow(slotProps.data)" style="height: 2.5rem; width: 2.5rem; border-radius: 980px;">
                        <SvgEllipsis className="table-licenses-svg" color="var(--button-normal-color)"/>
                    </Button>
                </div>
            </template>
        </Column>
    </DataTable>

    <!-- DIALOGS -->

    <!-- License Window -->
    <LicenseWindowDialog :showDialog="showLicenseWindow" :license="focusedLicense" @close="showLicenseWindow = false" @refresh-licenses-table="$emit('refresh-licenses-table')" @delete-serial-number="showLicenseWindow = false; deleteSerialNumber(focusedLicense)"/>

    <!-- Delete license -->
    <ConfirmationDeleteSerialNumberDialog :showDialog="showConfirmationDeleteSerialNumberDialog" :license="focusedLicense" @close="showConfirmationDeleteSerialNumberDialog = false" @refresh-licenses-table="$emit('refresh-licenses-table')"/>
</template>

<script setup>
// --- IMPORTS ---
import { ref, toRefs, computed, watchEffect, onMounted, onBeforeUnmount } from 'vue'
// PrimeVue
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Avatar from 'primevue/avatar'
import Button from 'primevue/button'
// vue
import ScrollDelegatesAvatars from './ScrollDelegatesAvatars.vue'
import ScrollDescriptionText from './ScrollDescriptionText.vue'
import StatusTag from '@/components/Licenses/Elements/StatusTag.vue'
import LicenseWindowDialog from '@/components/Dialogs/LicenseWindow/LicenseWindowDialog.vue'
import ConfirmationDeleteSerialNumberDialog from '@/components/Dialogs/Actions/ConfirmationDeleteSerialNumberDialog.vue'
import SvgUserMe from '@/components/SVGs/SvgUserMe.vue';
import SvgTrash from '@/components/SVGs/SvgTrash.vue';
import SvgEllipsis from '@/components/SVGs/SvgEllipsis.vue';
import SvgDownload from '@/components/SVGs/SvgDownload.vue'
// Other
import toastService from '@/composables/toastService';
import { useStore } from 'vuex'
import LicensesUtils from '@/composables/LicensesUtils';
import AvatarsUtils from '@/composables/AvatarsUtils'

import eventBus from '@/composables/eventBus.js';

const store = useStore()
const { allApplications, licensesSortingFunction, isOldActivation, isPendingNow, getLicenseRemainingPendingTimeLabel } = LicensesUtils(store)

const { getAvatarLabelFromFirstNameAndLastName, getTooltipValueForUser } = AvatarsUtils()

// --- PROPS ---
const props = defineProps({
    licenses: Array,
    licensesToShow: Array,
    licensesDatatableHeight: Number,
    selectedUser: Object
})
const { licensesToShow } = toRefs(props)

// --- User info ---
const user = computed(() => store.state.user.user)

// --- EMITS ---
const emit = defineEmits(['refresh-licenses-table', 'selected-user-changed', 'selected-licenses-changed'])

// --- DataTable : Expansions ---
const expandedRowGroups = ref(allApplications.value)

// --- Selection Licenses ---
const selectedLicenses = ref([])
watchEffect(() => { // whenever store.state.licenses.licenses changes (due to delegates modifications for example), licensesToShow changes => selectedLicenses must change !
    // selectedLicenses takes the updated values from licensesToShow AND makes sure all his elements are in licensesToShow
    selectedLicenses.value = licensesToShow.value.filter((license) => selectedLicenses.value.some((l) => l.serial_number === license.serial_number))
})
watchEffect(() => {
    emit('selected-licenses-changed', selectedLicenses.value)
})

// --- Focused license ---
const focusedLicense = ref(null)

// --- Edit a license (double click on a row or click on the button on the right) ---
const showLicenseWindow = ref(false)
const openLicenseWindow = (data) => {
    focusedLicense.value = data
    showLicenseWindow.value = true
}

// --- Click on a remove button ---
const showConfirmationDeleteSerialNumberDialog = ref(false)
const deleteSerialNumber = (license) => {
    if (!isOldActivation(license) && (license.current_status.activated === true) && license.current_status.activeUser && license.current_status.activeUser.id == user.value.id) {
        toastService.add({ severity: 'error', summary: "Removal Error", detail: 'This serial number can not be removed because you are currently running the license.', life: 5000 });
    }
    else { // It is possible for me to remove !
        focusedLicense.value = license
        showConfirmationDeleteSerialNumberDialog.value = true
    }
}

// --- Table subgroups (applications) info ---
const applicationsInfo = computed(() => {
    return allApplications.value.map((application) => {
        if (licensesToShow.value.filter((license) => license.product.application === application).length>0) {
            const latestVersion = licensesToShow.value.filter((license) => license.product.application === application)[0].product.latestVersion
            const totalCounter = licensesToShow.value.filter((license) => license.product.application === application).length
            const availableCounter = licensesToShow.value.filter((license) => license.product.application === application && !license.current_status.activated).length
            return {
                "latest-version": `${latestVersion}`,
                "total": `${totalCounter}`,
                "available": `${availableCounter}`,
                "inuse": `${totalCounter-availableCounter}`
            }
        }
        return {
            "latest-version": '',
            "total": '',
            "available": '',
            "inuse": ''
        }
    })
})

// --- Open application section when a new serial number is added ---
function handleNewSerialNumberAdded(event) {
    const newSerialNumberAppName = event.detail.applicationName
    if (!expandedRowGroups.value.some((appName) => appName == newSerialNumberAppName)) {
        expandedRowGroups.value = [...expandedRowGroups.value, newSerialNumberAppName]
    }
}
onMounted(() => {
  eventBus.addEventListener('new-serial-number-added', handleNewSerialNumberAdded);
});
onBeforeUnmount(() => {
  eventBus.removeEventListener('new-serial-number-added', handleNewSerialNumberAdded);
});

// -- SORT --
const licensesToShowSorted = computed(() => {
    return [...licensesToShow.value].sort(licensesSortingFunction)
})

// -- TRACK POTENTIAL PENDING --
const licensesToShowSortedUpdating = ref([])
let timeoutId;
onMounted(() => {
  function updatePotentialPendingTime() {
    licensesToShowSortedUpdating.value = licensesToShowSorted.value.map((license) => {
        let res = {...license}
        if (res.pending) {
            if (res.pending.pending_release) {
                res = {...res, pending: {...res.pending, pending_release: {...res.pending.pending_release, remaining_time: getLicenseRemainingPendingTimeLabel(res.pending.pending_release.exp_datetime)}}}
            }
            if (res.pending.pending_reactivate) {
                res = {...res, pending: {...res.pending, pending_reactivate: {...res.pending.pending_reactivate, remaining_time: getLicenseRemainingPendingTimeLabel(res.pending.pending_reactivate.exp_datetime)}}}
            }
        }
        return res
    })
    // Execute this function again after 1 second
    timeoutId = setTimeout(updatePotentialPendingTime, 1000);
  }
  // Start the interval
  updatePotentialPendingTime();
})
onBeforeUnmount(() => {
  // Clear the timeout when the component is unmounted
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
});

// (delete icon red color)
const delItemSerialNumber = ref(null)
</script>

<style scoped>
/* Columns header */
:deep(.p-resizable-column) {
    padding: 16px 5px;
}
:deep(.resize .p-column-resizer) {
    background-color: var(--table-column-separator-color);
    margin-top: 0.4rem;
    height: 80%;
    width: 0.03rem;
    margin-right: 0.1rem;
}
/* Checkbox */
:deep(.p-checkbox-box svg) {
    font-weight: 900;
}
:deep(.p-column-header-content .p-checkbox) {
    display: none;
}
/* Groups header */
.p-datatable :deep(.p-datatable-tbody .p-rowgroup-header td) {
    padding: 0.65rem 0.2rem;
    background-color: var(--table-row-color);
    border-top: 1px solid var(--table-row-separator-color);
}
.p-datatable .group-header-content, .p-datatable :deep(.p-datatable-tbody .p-rowgroup-header .p-icon) {
    color: var(--theme-font-color);
}
.p-datatable :deep(.p-datatable-tbody .p-rowgroup-header td .p-icon) {
    transform: translateY(2px);
}
.p-datatable :deep(.p-datatable-tbody .p-rowgroup-header td img) {
    transform: translateY(-2.5px);
}
.p-datatable :deep(.p-datatable-tbody .p-rowgroup-header td .status-summary-total) {
    position: absolute;
    right: 230px;
    top: 22px;
}
.p-datatable :deep(.p-datatable-tbody .p-rowgroup-header td .status-summary-available) {
    position: absolute;
    right: 110px;
    top: 22px;
}
.p-datatable :deep(.p-datatable-tbody .p-rowgroup-header td .status-summary-inuse) {
    position: absolute;
    right: 20px;
    top: 22px;
}
#latest-version-text {
    text-decoration: none;
    color: var(--theme-font-color);
}
#latest-version-text:visited {
    color: var(--theme-font-color);
}
#latest-version-text:hover {
    border-bottom: 1px solid var(--theme-font-color);
}
/* ROWS */
:deep(.row:hover) {
    background-color: var(--table-row-hover-color);
}
.p-datatable :deep(.p-datatable-tbody > tr.p-highlight) {
    background-color: var(--table-row-selected-color);
}
/* Cells */
.p-datatable :deep(.p-datatable-tbody td) {
    padding-top: 0px;
    padding-bottom: 0px;
}
/* Right side buttons */
.p-datatable :deep(.p-button:enabled:hover) {
    cursor: pointer;
}
.p-datatable :deep(#delete-license-button:hover) {
    color: var(--button-danger-color);
}
</style>